import { Alert } from "@heroui/react"
import { CircleAlert, CircleCheck, Info, TriangleAlert } from "lucide-react"

type AlertStatus = "accent" | "danger" | "success" | "warning"

const ICONS = {
  accent: Info,
  danger: CircleAlert,
  success: CircleCheck,
  warning: TriangleAlert,
}

export function AppAlertIndicator({ status }: { status: AlertStatus }) {
  const Icon = ICONS[status]

  return (
    <Alert.Indicator>
      <Icon aria-hidden className="size-5" />
    </Alert.Indicator>
  )
}
